module.exports = __webpack_public_path__ + "img/growing-plant.4f0b39df.svg";